import { createTypes, createAction } from "lib/action";

const LOAD_PERMISSION = createTypes("permissionmasterdata", "load");
const LOAD_PERMISSION_DETAIL = createTypes(
  "permissiondetailmasterdata",
  "load"
);
const CREATE_PERMISSION = createTypes("permissionmasterdata", "create");
const UPDATE_PERMISSION = createTypes("permissionmasterdata", "update");
const REMOVE_LISTS = `REMOVE_LISTS`;

function removeLists() {
  return {
    type: REMOVE_LISTS
  };
}
const loadPermission = {
  request: (data, loading, token) =>
    createAction(LOAD_PERMISSION.REQUEST, { data, loading, token }),
  success: (lists, page) =>
    createAction(LOAD_PERMISSION.SUCCESS, { lists, page }),
  failure: () => createAction(LOAD_PERMISSION.FAILURE)
};

const loadPermissionDetail = {
  request: (data, token) => createAction(LOAD_PERMISSION_DETAIL.REQUEST, { data, token }),
  success: permission =>
    createAction(LOAD_PERMISSION_DETAIL.SUCCESS, { permission }),
  failure: () => createAction(LOAD_PERMISSION_DETAIL.FAILURE)
};

const createPermission = {
  request: (data, cb, token, user_id) =>
    createAction(CREATE_PERMISSION.REQUEST, {
      data,
      cb, token, user_id
    }),
  success: res => createAction(CREATE_PERMISSION.SUCCESS, { res }),
  failure: () => createAction(CREATE_PERMISSION.FAILURE)
};

const updatePermission = {
  request: (data, cb, token, user_id) =>
    createAction(UPDATE_PERMISSION.REQUEST, {
      data,
      cb, token, user_id
    }),
  success: res => createAction(UPDATE_PERMISSION.SUCCESS, { res }),
  failure: () => createAction(UPDATE_PERMISSION.FAILURE)
};

export {
  CREATE_PERMISSION,
  createPermission,
  loadPermission,
  LOAD_PERMISSION,
  REMOVE_LISTS,
  removeLists,
  LOAD_PERMISSION_DETAIL,
  loadPermissionDetail,
  updatePermission,
  UPDATE_PERMISSION
};
